import Block from './block';

export default {
	component: Block,
	getChildren(props) { return [ ...props.content, ...props.button ] }
};

